<template>

  <DashboardLayout :menu-items="dashboardRoutesBaseOnAccess()">

    <div class="text-dashboard w-100 h-auto">
      <m-update-site-message-1/>
      <router-view name="dashboard"/>
    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions} from 'vuex'
import DashboardLayout from '../../components/dashboard/Layout'
import {dashboardMenu, dashboardRoutesBaseOnAccess} from '../../routes/DashboardRoutes'
import WidgetWallet from "../../components/dashboard/Wallet/WidgetWallet";
import DashboardMobileProfile from "../../components/dashboard/DashboardMobileProfile";

export default {
  name: "DashboardTemplate",
  components: {DashboardLayout, WidgetWallet, DashboardMobileProfile},
  data() {
    return {
      dashboardMenu,
    }
  },
  methods: {
    dashboardRoutesBaseOnAccess,
    ...mapActions({
      logout: "Authentication/logout"
    })
  }

};
</script>



<style scoped>
.text-dashboard {
  width: 100%;
  max-width: 100%;
  height: auto;
  background: transparent;
  margin: 0;
  border-radius: 0;
  padding: 0;
  border: none;
  box-shadow: none;
}


</style>